<template>
  <div
    class="w-full h-full shrink-0 snap-center snap-always"
  >
    <img
      :src="image.src"
      :alt="image?.description"
      :loading="image?.loading ?? 'lazy'"
      :width="image.width"
      :height="image.height"
      draggable="false"
      class="w-full h-full object-cover"
    >
  </div>
</template>

<script setup lang="ts">
import type { SwipeImage } from './types'

defineProps<{
  image: SwipeImage
}>()
</script>
